module.exports = __webpack_public_path__ + "static/media/demo2.fd85d78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/demo2.png
// module id = 946
// module chunks = 0